import { FormControl, FormLabel, Input, FormHelperText,Text, Button, Select, HStack, Tab, TabList, TabPanel, TabPanels, Tabs, VStack } from "@chakra-ui/react";
import React from "react";

import { useForm, Controller } from "react-hook-form"

type SpecialTap = {
    size : string,
    tpi: number
}

type CustomTap = {
    custom_size: number,
    custom_tpi:number,
    overall_length: number,
    thread_length:number,
    square_length:number,
    shank_diameter:number,
    size_of_square:number
}

type FormValues = {
  MeasureUnit: string,
  TapStyle: string,
  TapMaterial: string,
  TapType?: SpecialTap | CustomTap,
  TapChamfer: string,
  TapFlutes: number,
  ClassOfFit: string,
  SurfaceTreatment: string
}

type TapDesignProps = {
  nextAction: any
}

export const TapDesign = ({nextAction} : TapDesignProps) => {
  const { handleSubmit, control } = useForm<FormValues>()

  return (
    <VStack> 
    <FormControl onSubmit={handleSubmit((data) => console.log(data))}>
      <Controller
        control={control}
        name="MeasureUnit"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <Select onChange={onChange} value={value} placeholder='Select Measure Unit'>
            <option value='inch'>inch</option>
            <option value='milimeter'>milimeter</option>
           
          </Select>

        )}
      />

      <Controller
        control={control}
        name="TapStyle"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <Select onChange={onChange} value={value} placeholder='Select Tap Style'>
          <option value="Spiral Point">Spiral Point</option>
          <option value="Straight Flute" >Straight Flute</option>
          <option value="Spiral Flute" >Spiral Flute</option>
          <option value="Spiral Flute (Fast)" >Spiral Flute (Fast)</option>
          <option value="Tru Flo (Form)" >Tru Flo (Form)</option>
          <option value="Extension" >Extension</option>
          <option value="Extension Spiral Flute" >Extension Spiral Flute</option>
          <option value="Extension Spiral Point" >Extension Spiral Point</option>

          </Select>
        )}
      />

      <Controller
        control={control}
        name="TapMaterial"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <Select onChange={onChange} value={value} placeholder='Select Tap Material'>
            <option value='HSS'>HSS</option>
            <option value='HSSE'>HSSE</option>
            <option value='CARBIDE'>CARBIDE</option>

          </Select>
        )}
      />

<Controller
        control={control}
        name="TapType"
        render={({ field: { onChange, onBlur, value, ref } }) => (
            <Tabs variant='enclosed'>
            <TabList>
              <Tab>Special</Tab>
              <Tab>Custom</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <VStack> 
             
                <Select onChange={onChange} placeholder='Size' value={(value && 'size' in value) ? value.size : ''} >
             
		                    <option value="0.0600">#0</option><option value="0.0860">#2</option><option value="0.0990">#3</option><option value="0.1120">#4</option><option value="0.1250">#5</option><option value="0.1380">#6</option><option value="0.1640">#8</option><option value="0.1900">#10</option><option value="0.2100">.210"</option><option value="0.2160">#12</option><option value="0.2420">#14</option><option value="0.1563">5/32"</option><option value="0.1875">3/16"</option><option value="0.2188">7/32"</option><option value="0.2500">1/4"</option><option value="0.2813">9/32"</option><option value="0.3125">5/16"</option><option value="0.3438">11/32"</option><option value="0.3750">3/8"</option><option value="0.4063">13/32"</option><option value="0.4375">7/16"</option><option value="0.4688">15/32"</option><option value="0.5000">1/2"</option><option value="0.5156">33/64"</option><option value="0.5625">9/16"</option><option value="0.6250">5/8"</option><option value="0.6406">41/64"</option><option value="0.6875">11/16"</option><option value="0.7500">3/4"</option><option value="0.7656">49/64"</option><option value="0.8000">.800"</option><option value="0.8125">13/16"</option><option value="0.8750">7/8"</option><option value="0.9375">15/16"</option><option value="1.0000">1"</option><option value="1.0625">1 1/16"</option><option value="1.1250">1 1/8"</option><option value="1.1875">1 3/16"</option><option value="1.2500">1 1/4"</option><option value="1.3125">1 5/16"</option><option value="1.3750">1 3/8"</option><option value="1.4375">1 7/16"</option><option value="1.5000">1 1/2"</option><option value="1.5625">1 9/16"</option><option value="1.6250">1 5/8"</option><option value="1.7500">1 3/4"</option><option value="1.8750">1 7/8"</option><option value="2.0000">2"</option><option value="2.1250">2 1/8"</option><option value="2.2500">2 1/4"</option><option value="2.3750">2 3/8"</option><option value="2.5000">2 1/2"</option><option value="2.7500">2 3/4"</option><option value="3.0000">3"</option><option value="3.1250">3 1/8"</option><option value="3.2500">3 1/4"</option><option value="3.5000">3 1/2"</option><option value="3.7500">3 3/4"</option><option value="4.0000">4"</option><option value="Custom">Custom</option>		             

          </Select>

          <HStack> 
              <Text fontSize='md'>Custom TPI</Text>
                <Input
                  value={(value  && 'custom_tpi' in value) ? value.custom_tpi : ''}
                  onChange={onChange}
                  placeholder='Custom TPI'
                  size='md'
                />
                </HStack>
                </VStack>
              </TabPanel>
              <TabPanel>
              <VStack>
                <HStack> 
              <Text fontSize='md'>Custom Size</Text>
                <Input
                  value={(value  && 'custom_size' in value) ? value.custom_size : ''}
                  onChange={onChange}
                  placeholder='Custom Size'
                  size='md'
                />
                </HStack>

                <HStack> 
              <Text fontSize='md'>Custom TPI</Text>
                <Input
                  value={(value  && 'custom_tpi' in value) ? value.custom_tpi : ''}
                  onChange={onChange}
                  placeholder='Custom TPI'
                  size='md'
                />
                </HStack>
                <HStack> 
              <Text fontSize='md'>Overall Length</Text>
                <Input
                  value={(value  && 'overall_length' in value) ? value.overall_length : ''}
                  onChange={onChange}
                  placeholder='Overall Length'
                  size='md'
                />
                </HStack>
              <HStack> 
                <Text fontSize='md'> Thread Length</Text>
                <Input
                  value={(value  && 'thread_length' in value) ? value.thread_length : ''}
                  onChange={onChange}
                  placeholder='Thread Length'
                  size='md'
                />
                </HStack>
                <HStack> 
                <Text fontSize='md'> Square Length</Text>
                <Input
                  value={(value  && 'square_length' in value) ? value.square_length : ''}
                  onChange={onChange}
                  placeholder='Square Length'
                  size='md'
                />
                </HStack>
                
                <HStack> 
                <Text fontSize='md'>Shank Diameter</Text>
                <Input
                  value={(value  && 'shank_diameter' in value) ? value.shank_diameter : ''}
                  onChange={onChange}
                  placeholder='Shank Diameter'
                  size='md'
                />
                </HStack>

                <HStack> 
                <Text fontSize='md'>Size of Square</Text>
                <Input
                  value={(value  && 'size_of_square' in value) ? value.size_of_square : ''}
                  onChange={onChange}
                  placeholder='Size of square'
                  size='md'
                />
                </HStack>
                
                </VStack>
              </TabPanel>
            </TabPanels>
          </Tabs>
          
          
        )}
      />
      <Controller
        control={control}
        name="TapChamfer"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <Select onChange={onChange} value={value} placeholder='Select Tap Chamfer'>
            <option value='Plug'>Plug</option>
            <option value='Bottom'>Bottom</option>
            <option value='Modified Bottom'>Modified Bottom</option>
            <option value='Taper'>Taper</option>

          </Select>
        )}
      />

      <Controller
        control={control}
        name="TapFlutes"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <HStack>
        
            <Select onChange={onChange} value={value} placeholder='N of Flutes'>
              <option value='3'>3</option>
              <option value='4'>4</option>
              <option value='5'>5</option>
              <option value='6'>6</option>
              <option value='7'>7</option>
              <option value='8'>8</option>
              <option value='9'>9</option>
              <option value='10'>10</option>
              <option value='12'>12</option>

            </Select></HStack>
        )}
      />

      <Controller
        control={control}
        name="ClassOfFit"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <Select onChange={onChange} value={value} placeholder='Class Of Fit'>
        <option>Select</option><option>1B</option><option>2B</option><option>2</option><option>3B</option><option>3</option><option>PLATING</option><option>Other</option>
          </Select>
        )}
      />

<Controller
        control={control}
        name="SurfaceTreatment"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <HStack>
         
            <Select onChange={onChange} value={value} placeholder='Surface Treatment'>
            <option value="RECOMMENDED">RECOMMENDED</option><option value="AlCrN">AlCrN</option><option value="CrC">CrC</option><option value="CrN">CrN</option><option value="N">N</option><option value="Nitride/Oxide">Nitride/Oxide</option><option value="Steam Oxide">Steam Oxide</option><option value="TiAlN">TiAlN</option><option value="TiCN">TiCN</option><option value="TiN">TiN</option><option value="Uncoated (Bright)">Uncoated (Bright)</option><option value="WC/C">WC/C</option>

            </Select></HStack>
        )}
      />

      <Button onClick={()=>{
        // @ts-ignore
        nextAction(2)}}>Next</Button>
    </FormControl>
    </VStack>
  );
};
